var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};


$('.pdp-offer-list-col .slider-wrapper').each(function(index) {
    var forSelector = $(`.js-pdp-offer-for${(index + 1)}`);
    var navSelector = $(`.js-pdp-offer-nav${(index + 1)}`);
    console.log("forSelector", forSelector);
    if ($(forSelector).length > 0) {
        $(forSelector).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            asNavFor: navSelector
        });

        $(navSelector).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: forSelector,
            dots: false,
            arrows: false,
            focusOnSelect: true,
            vertical: true,
            responsive: [{
                breakpoint: 992,
                settings: {
                    vertical: false,
                }
            }, ]
        });
    }
});



function totalPrice() {
    var totalPrice = 0;
    var price;
    var compareTotle = 0;
    var comPrice;
   
    $('.js_select_product:checked').each(function() {
        // Find the associated .js-select element for the checked checkbox
        price = $(this).closest('.js_checkbox_parent').find('.js-select option:selected').data('without-money');
        comPrice = $(this).closest('.js_checkbox_parent').find('.js-select option:selected').data('compareat-without-money');

        if (price) {
            price = parseFloat(price); // Convert the price to a float
            if (!isNaN(price)) {
                totalPrice += price; // Add to totalPrice only if it's a valid number
                console.log('Price: ' + price);
            } else {
                console.error('Invalid price format:', price);
            }
        }

        if (comPrice) {
            price = parseFloat(comPrice); // Convert the price to a float
            if (!isNaN(comPrice)) {
                compareTotle += comPrice; // Add to totalPrice only if it's a valid number
                console.log('Price: ' + comPrice);
            } else {
                console.error('Invalid price format:', comPrice);
            }
        }
       
    });
    var finalCompareTotal = totalPrice + compareTotle;
    
    $('#js_total_price').html(Shopify.formatMoney(totalPrice, $('body').attr('data-money-format')));
   // $('#js_compare_total_price').text(Shopify.formatMoney(finalCompareTotal, $('body').attr('data-money-format')));
    if (finalCompareTotal > totalPrice) {
        $('#js_compare_total_price').show();
        $('#js_compare_total_price').text(Shopify.formatMoney(finalCompareTotal, $('body').attr('data-money-format')));
    } else {
        $('#js_compare_total_price').hide();
    }
}
totalPrice()
$(document).on('click', '.js_select_btn', function(e) {
     
    let checkbox = $(this).closest('.pdp-offer-list-col').find('input[type="checkbox"]');
    let isChecked = !checkbox.is(':checked');
    checkbox.prop('checked', isChecked).trigger('change');
    // Find the closest .pdp-offer-list-col container
    let checkLength = $('.js_select_product:checked').length;
    if(checkLength > 0){
    $('.js_upsell_page_atc').text(`Add ${checkLength} Cart`);
    $('.js_upsell_page_atc').css('pointer-events', 'all');
    $('.js_upsell_page_atc').css('opacity', '1');
    }else{
        $('.js_upsell_page_atc').text(`please select product`);
        $('.js_upsell_page_atc').css('pointer-events', 'none');
        $('.js_upsell_page_atc').css('opacity', '0.5');
    }
    $('.pdp-offer-list-col .js_select_product').each(function() {

        if ($(this).prop("checked")) {

            $(this).parent('.pdp-offer-list-col')
                .find('.pdp-offer-wraper__right-box .button-wrapper button')
                .text("UNSELECT THIS NOW");
        } else {
            $(this).parent('.pdp-offer-list-col')
                .find('.pdp-offer-wraper__right-box .button-wrapper button')
                .text("SELECT THIS NOW");
        }
    });
    totalPrice();
});

$(document).on('click', '.js_select_product', function(e) {
    let checkLength = $('.js_select_product:checked').length;
    if(checkLength > 0){
        $('.js_upsell_page_atc').text(`Add ${checkLength} Cart`);
        $('.js_upsell_page_atc').css('pointer-events', 'all');
        $('.js_upsell_page_atc').css('opacity', '1');
        }else{
            $('.js_upsell_page_atc').text(`please select product`); 
            $('.js_upsell_page_atc').css('pointer-events', 'none');
            $('.js_upsell_page_atc').css('opacity', '0.5'); 
        }
    $('.pdp-offer-list-col .js_select_product').each(function() {

        if ($(this).prop("checked")) {
            $(this).parent('.pdp-offer-list-col')
                .find('.pdp-offer-wraper__right-box .button-wrapper button')
                .text("UNSELECT THIS NOW");

        } else {
            $(this).parent('.pdp-offer-list-col')
                .find('.pdp-offer-wraper__right-box .button-wrapper button')
                .text("SELECT THIS NOW");
        }
    });
    totalPrice();
});




$(document).on("change", ".seat-cover-product__col--parent .product_dropdown", function(e) {
    let option1 = option2 = option3 = null;
    let parent = $(e.target).closest('.seat-cover-product__col--parent');
    var product_id = parent.find(".product_dropdown option:selected").val();
    if (parent.find('[data-option-1]').length > 0) {
        option1 = parent.find('[data-option-1] option:selected').val();

    }

    if (parent.find('[data-option-2]').length > 0) {
        option2 = parent.find('[data-option-2] option:selected').val();
    }
    if (parent.find('[data-option-3]').length > 0) {
        option3 = parent.find('[data-option-3] option:selected').val();
    }

    let variant_id = null;
    let current_selected_option = null;

    if (option2 == null & option3 == null) {
        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}']`)).val();
    }
    if (option2 != null & option3 == null) {
        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}']`)).val();
    }
    if (option2 != null & option3 != null) {
        current_selected_option = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`));
        variant_id = $(parent.find(`select.actual-variantss option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`)).val();
    }
    let price = $(current_selected_option).attr('data-price');
    let comPrice = $(current_selected_option).attr('data-compareat-price');

    let is_available = $(current_selected_option).attr('data-available');
    let variantImage = (current_selected_option).data('image');

    if (variantImage) {
        $(parent.find(`.our-bestselling-products__box-img img`)).attr('src', variantImage);
    }
    $(parent.find(`select.actual-variantss`)).val(variant_id).trigger('change');

    $(parent.find(`.js_req_price`)).text(price);
    $(parent.find(`.js_com_price`)).text(comPrice);
    if (is_available == 'true') {
        $(parent.find(`.js_other_page_atc`)).text('add to cart');
        $(parent.find(`.js_other_page_atc`)).css('pointer-events', 'all');
        $(parent.find(`.js_other_page_atc`)).css('opacity', '1');
    } else {
        $(parent.find(`.js_other_page_atc`)).text('sold out');
        $(parent.find(`.js_other_page_atc`)).css('pointer-events', 'none');
        $(parent.find(`.js_other_page_atc`)).css('opacity', '0.5');
    }
    totalPrice();

});



$(document).on('click', '.js_upsell_page_atc', function(e) {
    e.preventDefault();
    var items = [];
    $('.js_select_product:checked').each(function() {
        // Find the associated .js-select element for the checked checkbox
        var variantId = $(this).closest('.js_checkbox_parent').find('.js-select').val(); // Adjust the selector as needed

        if (variantId) {
            items.push({
                id: variantId, // Variant ID from the value attribute
                quantity: 1 // Quantity parsed as an integer
            });
        }
    });
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
            items: items
        },
        success: function(cart) {
            //window.location = "/checkout";
        },
        error: function(XMLHttpRequest, textStatus) {
            console.error('Failed to add products to cart:', textStatus);
        }
    });

});